import React, { useState } from 'react';
import {
  Upload,
  Send,
  FileText,
  Sparkles,
  Layers
} from 'lucide-react';
import ResultsManagement from './ResultsManagement';
import PublishResults from './PublishResults';
import Reports from './Reports';

const ExamResults = () => {
  const [activeTab, setActiveTab] = useState('manage');

  const tabs = [
    { id: 'manage', name: 'Manage Results', icon: Upload, description: 'Enter & update grades' },
    { id: 'publish', name: 'Publish & Send', icon: Send, description: 'Visibility & Notifications' },
    { id: 'reports', name: 'Report Cards', icon: FileText, description: 'Generate & Download' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'manage': return <ResultsManagement />;
      case 'publish': return <PublishResults />;
      case 'reports': return <Reports />;
      default: return <ResultsManagement />;
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Premium Header Section */}
      <div className="bg-white border-b border-gray-100 sticky top-0 z-30 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <div className="p-1 rounded" style={{ backgroundColor: 'color-mix(in srgb, var(--primary-color, #4f46e5) 10%, white)' }}>
                  <Sparkles className="h-4 w-4" style={{ color: 'var(--primary-color, #4f46e5)' }} />
                </div>
                <h1 className="text-xl font-bold text-slate-900 tracking-tight">Academic Results Hub</h1>
              </div>
              <p className="text-slate-500 text-xs">Manage grades, publish results, and generate report cards</p>
            </div>

            {/* Tabs */}
            <div className="flex items-center bg-gray-100/80 p-1 rounded-lg">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                      flex items-center gap-2 px-4 py-1.5 rounded-md text-xs font-semibold transition-all
                      ${isActive
                        ? 'bg-white shadow-sm'
                        : 'text-slate-500 hover:text-slate-700'
                      }
                    `}
                    style={isActive ? { color: 'var(--primary-color, #4f46e5)' } : {}}
                  >
                    <Icon className="h-3.5 w-3.5" style={isActive ? { color: 'var(--primary-color, #4f46e5)' } : { color: '#94a3b8' }} />
                    {tab.name}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Content Portal */}
        <div className="animate-in fade-in duration-500">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default ExamResults;

